export const tableOverflow = () => `
  margin: 0 -70px;
  padding: 0 70px;
  
  ::-webkit-scrollbar {
    display: none;
  }
`;

export type DisableInputType = {
  disabled?: boolean;
};

export const disableInput = ({ disabled = false }: DisableInputType) => {
  if (disabled) {
    return `
        pointer-events: none;
        
        input {
          background-color: rgba(239, 239, 239, 0.3);
        }
      `;
  }
};

export const borderStyle = ({ theme }: any) =>
  `1px solid ${theme.colors.primary[10]}`;

export const defaultHeaderStyles = (props: any) => {
  const {
    theme: { space },
  } = props;

  return `
    display: flex;
    justify-content: space-between;
  
    border-top: ${borderStyle(props)};
    border-bottom: ${borderStyle(props)};
    padding: ${space[8]}px ${space[32]}px ${space[8]}px ${space[24]}px;
  `;
};
